import styled from 'styled-components';
import { css, breakpoints } from 'src/styles/theme';
import { rem } from 'polished';
import { Pages } from 'src/types/pages';
import { SummaryDealerDetailsStyled } from '../SummaryDealerDetailsStyled';

export const SummaryDealerDetailsAP = styled(SummaryDealerDetailsStyled)`
    border-bottom: ${rem('1px')} solid ${({ theme }) => theme.colors.grey12};
    border-top: ${rem('1px')} solid ${({ theme }) => theme.colors.grey12};

    .infoIcon {
        svg g {
            circle {
                stroke: ${({ theme }) => theme.colors.black};
                fill: ${({ theme }) => theme.colors.black};
            }

            line {
                stroke: ${({ theme }) => theme.colors.white};
            }
        }
    }

    .titleWrapper {
        .title {
            color: ${({ theme }) => theme.colors.black};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .Collapsible__contentInner {
        .container {
            .info {
                color: ${({ theme }) => theme.colors.black};

                .addr,
                .item {
                    font-size: ${rem('12px')};
                }
            }
        }
    }

    .linkButton {
        font-size: ${rem('12px')};
        color: ${({ theme }) => theme.colors.primary};
        border: unset;
        background: unset;
        text-align: left;
        padding: unset;
        cursor: pointer;
        position: relative;
        width: fit-content;
        display: flex;
        align-items: center;

        .txt {
            margin-right: ${rem('9px')};
        }

        .icon-wrapper {
            display: flex;

            svg {
                height: ${rem('7px')};
                width: ${rem('11px')};

                path {
                    fill: ${({ theme }) => theme.colors.primary} !important;
                    stroke: ${({ theme }) => theme.colors.primary} !important;
                }
            }
        }

        &:hover {
            &:after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 1px;
                background-color: ${({ theme }) => theme.colors.primary};
            }

            .icon-wrapper {
                svg path {
                    fill: ${({ theme }) => theme.colors.primary} !important;
                    stroke: ${({ theme }) => theme.colors.primary} !important;
                }
            }
        }
    }
`;
